// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"common":"a821bc912495a7d1","src_app_landing_landing_module_ts":"4803ad9f7132b3f9","src_app_home_home_module_ts":"e5a1bd06967543a6"}[chunkId] + ".js";
};